import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchState } from "../../../domain/models/fetch-state";
import { BrickType } from "../../../domain/models/unmapped-stockist/unmapped-stockist-data";
import { RemoteFetchBrick } from "../../../data/usecases/unmapped-stockist/remote-fetch-brick";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchBrickInterface {
  brick: BrickType[];
  brickState: FetchState;
  fetchBrick: Function;
  clearBrick: Function;
}

const initialStates = {
  brick: [],
  brickState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchbrickSlice: StateCreator<FetchBrickInterface> = (set) => ({
  ...initialStates,
  fetchBrick: async (id: number) => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remotebrick = new RemoteFetchBrick(
      `${BASE_URL}${Endpoints.FETCH_BRICK}`,
      axiosHttpClient
    );

    set(() => ({ brickState: FetchState.LOADING }));
    let result = await remotebrick.fetch(id);
    if (result) {
      set(() => ({
        brick: result.bricks,
        brickState: FetchState.SUCCESS,
      }));
    }
  },
  clearBrick: async () => {
    set(() => ({ brick: [] }));
  },
});
